<template>
    <v-container fluid>
        <v-row align="center"
               justify="center"
        >
            <v-col cols="12"
                   lg="8"
                   class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Page</h1>
                <v-btn to="/page/create">
                    <v-icon left small>fas fa-plus-circle</v-icon>
                    Add Page
                </v-btn>
            </v-col>
        </v-row>

        <v-row align="start"
               justify="center"
        >
            <v-col cols="12"
                   md="5"
                   align="center"
                   justify="center"
            >
                <PageEditForm/>
            </v-col>
            <v-col cols="12" md="3">
                <PageStructure/>
            </v-col>
        </v-row>

        <v-dialog v-model="deleteModal" width="500">
            <v-card>
                <v-card-title><v-icon left>fas fa-exclamation-triangle</v-icon>Delete Page: {{ name }} </v-card-title>
                <v-card-text>
                    <p>You are about to remove this page. Deleting this page will also remove it's related structure and the submission fields from the user area. This cannot be undone. Any existing user data for this page will be orphaned.</p>
                    <p>Click "Delete Page" to proceed.</p>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="toggleDeleteModal(false)">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" @click="destroy">
                        Delete Page
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import PageEditForm from './PageEditForm';
import PageStructure from './PageStructure';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { PageStructure, PageEditForm },

    computed: {
        ...mapState('pageEditor', ['steps', 'deleteModal', 'name'])
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'pageEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            saveData: 'pageEditor/saveData',
            destroyData: 'pageEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
